import 'jquery-singleclick';
import bootbox from "bootbox";
import formula_functions from './formula_functions';
import * as JSPM from 'jsprintmanager';

$(document).ready(function () {

    let $body = $('body');

    $body.on('mouseup', '.quick-value, .numeric-field, .numeric-custom', function (e) {
        e.preventDefault();
    });

    $body.on('focus', '.quick-value', function (e) {
        if ($(this).hasClass('numeric-custom')) {
            $(this).select();
        }
    });

    $body.on('click', '.no-permission', function (e) {
        toastr.error(translation.no_permission);
    });

    $body.on('focus', '.quick-value.html-field', function (e) {
        let $field = $(this),
            field_id = $(this).attr('id'),
            $html_modal = $('#html-modal'),
            value = $(this).attr('data-html');

        $('#save-html').attr('data-action', 'quick-add');

        $html_modal.attr('data-field-id', field_id).modal('show');
        tinymce.get("html-content").setContent(value);
    });

    $body.on('focus', '.quick-value.textarea-field', function (e) {
        let $field = $(this),
            field_id = $(this).attr('id'),
            $html_modal = $('#text-modal'),
            value = $(this).attr('data-value');

        $('#save-text').attr('data-action', 'quick-add');

        $html_modal.attr('data-field-id', field_id).modal('show');
        $('#text-content').val(value);
    });

    $body.on('focus', '.numeric-field, .numeric-custom', function (e) {
        $(this).select();
    });

    $(document).on('keypress', function (e) {
        if ($('.browse-table').length) {
            if (e.which === 13 && e.target.tagName !== 'TEXTAREA') {
                e.preventDefault();
                let $edit_buttons = $('.edit-buttons');

                if (!$edit_buttons.hasClass('d-none') && !$('.flatpickr-calendar.open').length) {
                    $('.save-edit').trigger('click', ['save_only']);
                }
                return false;
            }
        }
    });

    let linkRequest = null;

    $(document).on({
        mouseenter: function () {
            let record_id = $(this).attr('data-value'),
                table = $(this).attr('data-related-table'),
                field = $(this).attr('data-field'),
                $link = $(this).find('a'),
                old_link = $link.attr('href'),
                hyperlink = $(this).attr('data-hyperlink');

            if (record_id.length) {
                if (hyperlink && hyperlink.length) {
                    $(this).attr('data-old-link', old_link);
                    $link.attr('href', hyperlink).attr('target', '_blank');
                    $(this).addClass('relation-hyperlink');
                } else {
                    linkRequest = $.ajax({
                        type: 'GET',
                        url: '/relation/hyperlink',
                        data: {
                            record_id,
                            table,
                            field
                        },
                        success: (res) => {
                            if (res) {
                                $(this).attr('data-old-link', old_link);
                                $(this).attr('data-hyperlink', res);
                                $link.attr('href', res).attr('target', '_blank');
                                $(this).addClass('relation-hyperlink');
                            }
                        }
                    })
                }
            }
        },
        mouseleave: function () {
            if (linkRequest) {
                linkRequest.abort();
            }

            let $link = $(this).find('a'),
                old_link = $(this).attr('data-old-link');

            if (old_link && old_link.length) {
                $(this).removeClass('relation-hyperlink');
                $link.attr('href', old_link).removeAttr('target');
            }else{
                $(this).removeClass('relation-hyperlink');
            }
        }
    }, ".editable-td.relationship");

    $(document).on('click', '.popup-relation-link', function (e) {
        let href = $(this).attr('href');

        if (href === '#') {
            e.preventDefault();
        }
    });

    $(document).on('click', '.delete-edit-record', function (e) {
        e.preventDefault();
        let record_id = $(this).attr('data-record-id'),
            table_id = $(this).attr('data-id');

        if (confirm(translation.confirm_delete_record)) {
            $.ajax({
                url: "/delete-multiple-fields",
                type: 'DELETE',
                data: {
                    ids: record_id,
                    id: table_id
                },
                success: function (data) {
                    var failed_ids = data.failed_ids,
                        removed_ids = data.removed_ids,
                        failed_urls = data.failed_urls;

                    if (failed_ids.length) {
                        toastr.error(
                            `<a href="${failed_urls[0]}"><button type="button" class="btn btn-sm btn-light w-100 mt-2"> ${translation.view_record} </button></a>`,
                            data['failed_message']
                        );
                    } else {
                        window.location = `/browse/${table_id}`;
                    }
                },
                error: function (data) {
                    alert(data.responseText);
                }
            });
        }
    });


    $(document).on('click', '.edit-td', handleEditableClick);
    $(document).on('click', '.creatable-td', handleEditableRelationClick);
    $(document).on('click', '.trigger-edit', function (e) {
        if($(this).parents('.editable-td').hasClass('relationship')){
            if (!$(e.target).is('a') || !$(e.target).is('span')) {
                return;
            }
        }
        $(this).find('.edit-td').trigger('click');
    })

    function handleEditableRelationClick(e) {
        e.stopPropagation();
        e.preventDefault();
        let $data = $(this).find('a'), field = $(this).data('field'), field_type = $(this).attr('data-field-type'),
            value = $(this).parents('.editable-td').attr('data-value'),
            primary_keys = $(this).attr('data-primary-keys'), table_id = $(this).attr('data-related-table'),
            rendered_value = $data.text().trim(), id = $(this).attr('id'),
            mode = $(this).hasClass('creatable-td') ? 'quick_add' : 'editing', payload = [];

        if (field_type === 'relationship') {

            $('#save-relation').attr('data-action', 'updating');
            $('#remove-relation').attr('data-action', 'updating');

            $(document).find('.editable-td').removeClass('editing');
            $(this).parents('.editable-td').addClass('editing');

            if (primary_keys) {
                primary_keys = JSON.parse(primary_keys);
                for (let i = 0; i < primary_keys.length; i++) {

                    let $target = $('#' + primary_keys[i][0] + '.editable-td'), type = $target.attr('data-field-type'),
                        val = '';

                    if (type === 'relationship') {
                        val = $target.attr('data-value');
                    } else if ($target.find('input').length) {
                        val = $target.find('input').val();
                    }

                    payload.push([primary_keys[i][1], val]);
                }
            }


            let count = $(this).attr('data-related-records-count'), field = $(this).attr('data-field'),
                record = $(this).attr('data-record');
            $.ajax({
                type: 'GET', url: '/relation/editable', data: {
                    id: field, record: record, selected_id: value, payload
                }, success: function (table) {
                    $('#relation-title').text(table.name);

                    $('#relation-modal')
                        .attr('data-field-id', field)
                        .attr('data-table-id', table_id)
                        .attr('data-row-id', id)
                        .attr('data-mode', mode)
                        .modal('show');

                    $('#related-filter-container').html(table.filter_dom);

                    $('#relation-body')
                        .html(table.modal_dom)
                        .attr('data-record-count', count)
                        .attr('data-loaded-record-count', 50)
                        .attr('data-loading', 0)
                        .attr('data-is-loaded', 0);

                    if (value.length) {
                        $(".relation-row[data-id='" + value + "']").addClass('selected');
                        $('#save-relation').removeClass('d-none');
                        $('#remove-relation').removeClass('d-none');
                    }

                    if (!table.create_permission) {
                        $('#new-record-modal').attr('disabled', true);
                    }

                    setTimeout(function (e) {
                        attachResizeForRelationTable();
                    }, 200);
                }
            });
        }
    }

    function attachResizeForRelationTable() {
        $("#popup-table").colResizable({
            disable: true
        }).colResizable({
            liveDrag: true, gripInnerHtml: "<div class='grip'></div>", onResize: function (e) {
                let $container = $(e.currentTarget), $headers = $container.find('thead th'), type = 'popup',
                    source_id = $('#relation-modal').attr('data-field-id');

                $headers.each(function (index, $header) {
                    let id = $($header).attr('data-col');
                    if (id && id.length) {
                        let width = $($header).outerWidth();

                        $.ajax({
                            type: 'POST', url: '/tables/fields/width', data: {
                                id, width, source_id, type
                            }, success: function (res) {
                                console.log(res);
                            }
                        })
                    }
                });
            }
        });
    }

    function handleEditableClick(e) {
        e.preventDefault();
        e.stopPropagation();

        let $this = $(this).parents('.editable-td');

        $('body').removeClass('active-tab');
        $this.addClass('active-tab');

        let $data = $($this).find('a'),
            field = $($this).data('field'),
            field_type = $($this).attr('data-field-type'),
            value = $($this).attr('data-value'),
            table_id = $($this).attr('data-related-table'),
            rendered_value = $data.text().trim(),
            id = $($this).attr('id'),
            mode = $($this).hasClass('creatable-td') ? 'quick_add' : 'editing';

        if ($($this).parents('.button-container').length) {
            return;
        }

        if (field_type === 'relationship') {

            $('#save-relation').attr('data-action', 'updating');
            $('#remove-relation').attr('data-action', 'updating');
            // $('#new-record-modal').attr('disabled', true);

            $(document).find('.editable-td').removeClass('editing');
            $($this).addClass('editing');

            let count = $($this).attr('data-related-records-count'), field = $($this).attr('data-field'),
                record = $($this).attr('data-record');
            $.ajax({
                type: 'GET', url: '/relation/editable', data: {
                    id: field, record: record, selected_id: value
                }, success: function (table) {
                    $('#relation-title').text(table.name);

                    $('#relation-modal')
                        .attr('data-field-id', field)
                        .attr('data-table-id', table_id)
                        .attr('data-row-id', id)
                        .attr('data-mode', mode)
                        .modal('show');

                    $('#related-filter-container').html(table.filter_dom);

                    $('#relation-body')
                        .html(table.modal_dom)
                        .attr('data-record-count', count)
                        .attr('data-loaded-record-count', 50)
                        .attr('data-loading', 0)
                        .attr('data-is-loaded', 0);

                    if (value.length) {
                        $(".relation-row[data-id='" + value + "']").addClass('selected');
                        // $('#save-relation').removeClass('d-none');
                        $('#remove-relation').removeClass('d-none');
                    }

                    setTimeout(function (e) {
                        attachResizeForRelationTable();
                    }, 200);
                }
            });
        } else if (field_type === 'alert') {

            if ($('.create-field').length) {
                $('#save-alert').attr('data-action', 'updating');
            }

            let translations = {}, locale = 'en', $alert_model = $('#alert-modal');

            if ($alert_model.length) {
                translations = JSON.parse($('#alert-modal').attr('data-translations'));
                locale = $('#alert-modal').attr('data-lang');
            }

            let $field = $($this), field_id = $($this).attr('id'),
                event_options = JSON.parse($($this).attr('data-event-options')),
                alert_types = JSON.parse($($this).attr('data-alert-types')), payload = $($this).attr('data-value');

            $alert_model.attr('data-field-id', field_id).modal('show');

            if (payload.length) {
                payload = JSON.parse(payload);
            } else {
                payload = false;
            }

            let events = {
                at_event: translations.at_event,
                minutes_before: translations.minutes_before,
                hours_before: translations.hours_before,
                days_before: translations.days_before,
                minutes_after: translations.minutes_after,
                hours_after: translations.hours_after,
                days_after: translations.days_after,
                on_date: translations.on_date,
                at: translations.at
            };

            let types = {
                notification: translations.notification,
                sms: translations.sms,
                email: translations.email,
                message: translations.message,
            };

            $('#alert-type').empty();
            $('#event-option').empty();

            alert_types.forEach(function (value) {
                let option = `<option value="${value}">${types[value]}</option>`;
                $('#alert-type').append(option);
            });

            event_options.forEach(function (value) {
                let option = `<option value="${value}">${events[value]}</option>`;
                $('#event-option').append(option);
            });

            $('.selectpicker').selectpicker('refresh');

            if (payload) {
                $('#event-option').val(payload.option).trigger('change');
                $('#alert-type').val(payload.alert_type).trigger('change');
                $('#default-value').val(payload.default_value).attr('value', payload.default_value);
                $('#remove-alert').removeClass('d-none');
            }
        } else if (field_type === 'html') {
            let $field = $($this), field_id = $($this).attr('id'), $html_modal = $('#html-modal'),
                value = $($this).attr('data-value');

            $html_modal.attr('data-field-id', field_id).modal('show');
            tinymce.get("html-content").setContent(value);
        } else if (field_type === 'multiline') {
            let $field = $($this),
                field_id = $($this).attr('id'),
                $html_modal = $('#text-modal'),
                value = $($this).attr('data-value');

            $html_modal.attr('data-field-id', field_id).modal('show');
            $('#text-content').val(value);
        } else if (field_type === 'signature') {
            let $field = $($this), field_id = $($this).attr('id'), $SignatureModal = $('#Signature_modal'),
                value = $($this).attr('data-value');
            $SignatureModal.attr('data-field-id', field_id).modal('show');
            $SignatureModal.attr('data-source', 'related_section');
        } else {

            $data.addClass('d-none');

            if ($this.hasClass('bundle-quantity')) {
                let product_bundle = $this.attr('data-product-bundle'),
                    row_id = $this.parents('tr').attr('data-col');

                if (!product_bundle.length) {
                    let unsaved_bundle = $this.parents('tr').find('td[data-field-name="bundle"]').attr('data-value');
                    product_bundle = unsaved_bundle;
                }

                if (product_bundle && product_bundle.length) {
                    let $quantities = $(`.bundle-quantity[data-bundle-id="${product_bundle}"][data-row-id="${row_id}"]`);
                    $quantities.find('.edit-td').trigger('click');
                }
            }

            $.ajax({
                type: 'GET', url: '/tables/edit/render', data: {
                    field: field
                }, success: (res) => {
                    $($this).find('.edit-value-holder').remove();
                    $($this).append(`<div class="edit-value-holder">${res}</div>`);

                    if (field_type === 'multiselect' || field_type === 'multipleselect') {
                        if (value.length) {
                            $($this).find('.custom-value-edit').val(JSON.parse(value));
                        }
                    } else if (field_type === 'decimal' || field_type === 'currency' || field_type === 'number' || field_type === 'users' || field_type === 'visibility' || field_type === 'checkbox') {
                        if (field_type === 'users') {
                            let name = $this.attr('data-field-name');
                            if (name === 'multi_assigned_to') {
                                if (value.length) {
                                    value = JSON.parse(value);
                                    $($this).find('.custom-value-edit').selectpicker({
                                        container: 'body', noneSelectedText: translation.nothing_selected
                                    }).selectpicker('val', value).selectpicker('refresh');
                                }
                            } else {
                                $($this).find('.custom-value-edit').val(value);
                            }
                        } else {
                            $($this).find('.custom-value-edit').val(value);
                        }
                    } else {
                        $($this).find('.custom-value-edit').val(rendered_value);
                    }

                    $('.selectpicker').selectpicker({
                        container: 'body', noneSelectedText: translation.nothing_selected
                    }).selectpicker('refresh');

                    let date_format = $('meta[name="date-format"]').attr('content');


                    $($this).find('.datepicker-cl').flatpickr({
                        weekNumbers: true,
                        dateFormat: date_format,
                        allowInput: true,
                        onChange: function (selectedDates, dateStr, instance) {
                            $(instance.element).attr('value', dateStr);
                        }, onReady: function (dateObj, dateStr, instance) {
                            var $cal = $(instance.calendarContainer);
                            if ($cal.find('.flatpickr-clear').length < 1) {
                                $cal.append('<div class="flatpickr-clear">Clear</div>');
                                $cal.find('.flatpickr-clear').on('click', function () {
                                    instance.clear();
                                    instance.close();
                                    $(instance.element).trigger('keyup');
                                });
                            }
                        }
                    });

                    $($this).find('.datetimepicker-cl').flatpickr({
                        weekNumbers: true,
                        dateFormat: date_format + " H:i",
                        enableTime: true,
                        time_24hr: true,
                        allowInput: true,
                        onChange: function (selectedDates, dateStr, instance) {
                            $(instance.element).attr('value', dateStr);
                        },
                        onReady: function (dateObj, dateStr, instance) {
                            var $cal = $(instance.calendarContainer);
                            if ($cal.find('.flatpickr-clear').length < 1) {
                                $cal.append('<div class="flatpickr-clear">Clear</div>');
                                $cal.find('.flatpickr-clear').on('click', function () {
                                    instance.clear();
                                    instance.close();
                                    $(instance.element).trigger('keyup');
                                });
                            }
                        }
                    });

                    $($this).find('.timeonlypicker-cl').flatpickr({
                        weekNumbers: true,
                        noCalendar: true,
                        enableTime: true,
                        dateFormat: 'H:i',
                        time_24hr: true,
                        closeOnSelect: false,
                        allowInput: true,
                        onChange: function (selectedDates, dateStr, instance) {
                            $(instance.element).attr('value', dateStr);
                        },
                        onReady: function (dateObj, dateStr, instance) {
                            var $cal = $(instance.calendarContainer);
                            if ($cal.find('.flatpickr-clear').length < 1) {
                                $cal.append('<div class="flatpickr-clear">Clear</div>');
                                $cal.find('.flatpickr-clear').on('click', function () {
                                    instance.clear();
                                    instance.close();
                                    $(instance.element).trigger('keyup');
                                });
                            }
                        }
                    });

                    $($this).find('.custom-value-edit').focus();

                    // If field is numeric, select and focus
                    if ($($this).find('.numeric-custom').length) {
                        $($this).find('.numeric-custom').select().focus();
                    }

                    $('.edit-buttons').removeClass('d-none');
                }
            });
        }
    }

    $('#save-html').on('click', function (e) {
        let $html_modal = $('#html-modal'), id = $html_modal.attr('data-field-id'), $field = $(`#${id}`),
            value = tinymce.get("html-content").getContent(),
            text = tinymce.get("html-content").getContent({format: 'text'}), action = $(this).attr('data-action');

        if (action === 'quick-add') {
            $field.attr('data-html', value);
            $field.val(text);
        } else {
            if (!$field.attr('data-old-value')) {
                $field.attr('data-old-value', $field.attr('data-value'));
                $field.attr('data-old-text', $field.find('a').find('span').text().trim());
            }
            $field.attr('data-value', value);
            $field.find('a').find('span').text(text);
            $field.addClass('update');
            $('.edit-buttons').removeClass('d-none');
        }

        $html_modal.modal('hide');
    });

    $('#save-text').on('click', function (e) {
        let $text_modal = $('#text-modal'),
            id = $text_modal.attr('data-field-id'),
            $field = $(`#${id}`),
            value = $('#text-content').val(),
            text = value,
            action = $(this).attr('data-action');

        if (action === 'quick-add') {
            $field.attr('data-value', value);
            $field.val(text);
        } else {
            if (!$field.attr('data-old-value')) {
                $field.attr('data-old-value', $field.attr('data-value'));
                $field.attr('data-old-text', $field.find('a').find('span').text().trim());
            }
            $field.attr('data-value', value);
            $field.find('a').find('span').text(text);
            $field.addClass('update');
            $('.edit-buttons').removeClass('d-none');
        }

        $text_modal.modal('hide');
    });

    $('#cancel-html-save').on('click', function (e) {
        let $html_modal = $('#html-modal');
        $html_modal.modal('hide');
    });

    $('#cancel-text-save').on('click', function (e) {
        let $text_modal = $('#text-modal');
        $text_modal.modal('hide');
    });

    $(document).on('change keyup', '.custom-value-edit:not(.quick-value)', delay(function (e) {

        if (e.which === 13) {
            e.preventDefault();
        }

        $(this).parents('.editable-td').removeClass('mapped');

        let $section = $(this).parents('.lazy-load-section'),
            section_table_name = $section.attr('data-table-name');

        let $td = $(this).parents('.editable-td');
        if ($td.hasClass('bundle-quantity')) {
            let product_bundle = $td.attr('data-product-bundle'),
                row_id = $td.parents('tr').attr('data-col'),
                quantity_value = $(this).val();

            if (decimal_separator !== '.') {
                quantity_value = quantity_value.split(',').join('.');
            }

            if (!product_bundle.length) {
                let unsaved_bundle = $td.parents('tr').find('td[data-field-name="bundle"]').attr('data-value');
                if (unsaved_bundle && unsaved_bundle.length) {
                    product_bundle = unsaved_bundle;
                }
            }

            if (product_bundle && product_bundle.length) {
                let $quantities = $(`.bundle-quantity[data-bundle-id="${product_bundle}"][data-row-id="${row_id}"]`);
                $quantities.each(function (index, $quantity) {
                    let $quan = $($quantity),
                        component_quantity = $quan.attr('data-component-quantity'),
                        quantity = quantity_value * component_quantity;
                    if (checkDecimalPlaces(quantity, decimal_numbers)) {
                        quantity = quantity.toFixed(decimal_numbers);
                        quantity = parseFloat(quantity);
                    }
                    if (decimal_separator !== '.') {
                        quantity = quantity.toString().split('.').join(',');
                    }
                    $quan.find('.custom-value-edit').val(quantity).trigger('keyup');
                });
            }
        }

        if ($(this).hasClass('numeric-custom')) {
            let $row = $(this).parents('.edit-hover'), $column = $(this).parents('.editable-td'),
                col_id = parseInt($column.attr('data-field')), $formulas = $($row).find('.browse-formula'),
                payload = [];

            if (formulaOrderEnabledTenant()) {
                $formulas = $($row).find('.browse-formula').sort(function (a, b) {
                    return ($(b).data('order')) < ($(a).data('order')) ? 1 : -1;
                });
            }

            $formulas.each(function (i, $formula) {
                let holders = JSON.parse($($formula).attr('data-holders')),
                    id = parseInt($($formula).attr('data-field')), action = 'edit',
                    table_id = $($row).parents('.browse-table').attr('data-table-id'),
                    record_id = $($row).attr('data-col'),
                    data = {},
                    $section = $($row).parents('.browse-table').parents('.tbl-section.related');

                if (holders.includes(col_id)) {
                    $(holders).each(function (i, holder) {
                        let $holder = $($row).find('.editable-td[data-field="' + holder + '"]');
                        if ($holder.find('.custom-value-edit').length) {
                            data[holder] = $holder.find('.custom-value-edit').val();
                        } else {
                            data[holder] = $($row).find('.editable-td[data-field="' + holder + '"]').attr('data-value');
                        }
                    });

                    if ($section.length) {
                        payload.push({
                            id,
                            data,
                            action,
                            table_id,
                            record_id,
                            parent_table: $section.attr('data-owner-table'),
                            owner_record: $section.attr('data-owner-record')
                        });
                    } else {
                        payload.push({
                            id, data, action, table_id, record_id
                        });
                    }
                }
            });

            $.ajax({
                type: 'GET', url: '/parse_formula/browse', data: {
                    payload
                }, success: function (data) {
                    Object.keys(data).forEach(function (key) {
                        if (data[key] !== 'invalid') {
                            let $formula = $($row).find(`.browse-formula[data-field="${key}"]`);

                            if (!$($formula).attr('data-old-value')) {
                                $($formula).attr('data-old-value', $($formula).find('a').find('span').text().trim());
                            }

                            $($formula).find('a').find('span').text(data[key]);
                        }
                    });

                    let bundle_sections = ['Quote_products', 'Invoice_Products', 'Sales_order_products']

                    if (tenant_name === 'dobrovita' && bundle_sections.includes(section_table_name)) {
                        updateBundleSubTotal($section, $row);
                    }

                    if (e.type === 'keyup') {
                        formula_functions.processSectionFormulas(true);
                    }
                }
            })
        }
    }, 200));

    $('.cancel-edit').on('click', function (e) {
        let $custom_edits = $('.custom-value-edit'), $relations = $('.editable-td.update'),
            $formulas = $('.browse-formula'), $mapped = $('.editable-td.mapped'),
            $section_formulas = $('.section-formula-update');

        $('.selectpicker').selectpicker('toggle');

        $custom_edits.each(function (i, $edit) {
            let $editable = $(this).parents('.editable-td');

            $($edit).parents('.edit-value-holder').remove();
            $editable.find('a').removeClass('d-none');
            if ($editable.hasClass('error')) {
                $editable.removeAttr('title');
            }
            $editable.removeClass('error');
        });

        $relations.each(function (i, $edit) {
            let old_value = $($edit).attr('data-old-value'), old_text = $($edit).attr('data-old-text');

            $($edit).attr('data-value', old_value).removeAttr('data-old-value');
            $($edit).find('a').find('span').text(old_text).removeAttr('data-old-text');
            $($edit).removeClass('update');
        });

        $formulas.each(function (i, $formula) {
            if ($($formula).attr('data-old-value')) {
                let old_value = $($formula).attr('data-old-value');
                $($formula).find('a').find('span').text(old_value);
                $($formula).removeAttr('data-old-value');
            }
        });

        $mapped.each(function (i, $map) {
            if ($($map).attr('data-old-value')) {
                let old_value = $($map).attr('data-old-value');
                $($map).find('a').find('span').text(old_value);
                $($map).removeAttr('data-old-value');
            }
        });

        $section_formulas.each(function (i, $map) {
            if ($($map).attr('data-old-value')) {
                $($map).val($($map).attr('data-old-value')).removeClass('section-formula-update');
                $($map).removeAttr('data-old-value');
            }
        });

        $('.edit-buttons').addClass('d-none');
    });

    $(document).on('click', '.save-edit', function (e, action, target_table) {

        let $related_sections = $('.tbl-section.related'), $formulas = $('.browse-formula'),
            $section_formulas = $('.section-formula-update'), grouped_payload = [],
            height_from_top = $(window).scrollTop();

        if ($related_sections.length) {
            $related_sections.each(function (index, $related_section) {
                let $custom_edits = $($related_section).find('.custom-value-edit:not(.bootstrap-select)'),
                    table = $($related_section).find('.browse-table').attr('data-table-id'), payload = [],
                    $relations = $($related_section).find('.browse-table').find('.editable-td.update'),
                    owner_record = $($related_section).attr('data-owner-record'),
                    owner_table = $($related_section).attr('data-owner-table'),
                    $mapped = $($related_section).find('.editable-td.mapped');

                $custom_edits.each(function (i, $edit) {
                    let $editable = $(this).parents('.editable-td'), field_id = $editable.attr('data-field'),
                        record_id = $(this).parents('.edit-hover').attr('data-col'), value = $(this).val();

                    if (record_id.length) {
                        if ($editable.hasClass('error')) {
                            $editable.removeAttr('title');
                        }
                        $editable.removeClass('error');

                        payload.push({
                            field_id, record_id, value
                        });
                    }
                });

                $relations.each(function (i, $edit) {
                    let field_id = $($edit).attr('data-field'),
                        record_id = $($edit).parents('.edit-hover').attr('data-col'),
                        value = $($edit).attr('data-value');

                    $($edit).removeAttr('data-old-text').removeAttr('data-old-value');

                    payload.push({
                        field_id, record_id, value
                    });
                });

                $mapped.each(function (i, $edit) {
                    let field_id = $($edit).attr('data-field'),
                        record_id = $($edit).parents('.edit-hover').attr('data-col'),
                        value = $($edit).attr('data-value');

                    $($edit).removeAttr('data-old-text').removeAttr('data-old-value');

                    payload.push({
                        field_id, record_id, value
                    });
                });

                if (payload.length) {
                    grouped_payload.push({
                        table,
                        payload,
                        owner_record,
                        owner_table,
                        type: 'related',
                        section_id: $($related_section).attr('data-section-id')
                    });
                }
            });
        } else {
            let target = $('.search-table').length ? '.search-table' : '.browse-table',
                $custom_edits = $('.custom-value-edit:not(.bootstrap-select)'),
                table = $('.browse-table').attr('data-table-id'), payload = [],
                $relations = $(target).find('.editable-td.update'), $mapped = $(target).find('.editable-td.mapped');

            $custom_edits.each(function (i, $edit) {
                let $editable = $(this).parents('.editable-td'), field_id = $editable.attr('data-field'),
                    record_id = $(this).parents('.edit-hover').attr('data-col'), value = $(this).val();

                if (record_id.length) {
                    if ($editable.hasClass('error')) {
                        $editable.removeAttr('title');
                    }
                    $editable.removeClass('error');

                    payload.push({
                        field_id, record_id, value
                    });
                }
            });

            $relations.each(function (i, $edit) {
                let field_id = $($edit).attr('data-field'),
                    record_id = $($edit).parents('.edit-hover').attr('data-col'), value = $($edit).attr('data-value');

                $($edit).removeAttr('data-old-text').removeAttr('data-old-value');

                payload.push({
                    field_id, record_id, value
                });
            });

            $mapped.each(function (i, $edit) {
                let field_id = $($edit).attr('data-field'),
                    record_id = $($edit).parents('.edit-hover').attr('data-col'), value = $($edit).attr('data-value');

                $($edit).removeAttr('data-old-text').removeAttr('data-old-value');

                payload.push({
                    field_id, record_id, value
                });
            });

            if (payload.length) {
                grouped_payload.push({
                    table, payload, type: 'browse'
                });
            }
        }

        $.ajax({
            type: 'POST', url: '/tables/edit/fields', data: {
                grouped_payload, height_from_top
            }, success: function (res) {

                console.log(action);
                if (!res.errors) {
                    if (!$('.save-record-only').length) {
                        showAlert(translation.fields_updated, 'alert-success');
                    }
                    renderUpdatedPayload(res.updates);

                    $formulas.each(function (i, $formula) {
                        if ($($formula).attr('data-old-value')) {
                            $($formula).removeAttr('data-old-value');
                        }
                    });

                    $section_formulas.each(function (i, $map) {
                        if ($($map).attr('data-old-value')) {
                            $($map).removeAttr('data-old-value').removeClass('section-formula-update');
                        }
                    });
                    formula_functions.executeFormulas();

                    if (action === 'save_only') {
                        $('.save-record-only').trigger('click', ['save']);
                    } else if (action === 'save_with_filter') {
                        setTimeout(function (e) {
                            applySectionFilter(target_table);
                        }, 500);
                    }else if (action === 'save_with_sort') {
                        setTimeout(function (e) {
                            target_table.trigger('click');
                        }, 500);
                    } else if (action === 'save_with_filter_points') {
                        $('input[name="tokce_c"][id="1796"]').trigger('change', ['update_sections'])
                        $('input[name="vrednost_ene_toke_c"][id="1810"]').trigger('change', ['update_sections'])
                    } else {
                        $('#CreateSave').trigger('click', ['save']);
                    }
                } else {
                    renderUpdateErrors(res.errors);
                }
            }
        });
    });

    $(document).on('click', '#quick-add, .quick-add', function (e) {
        e.preventDefault();
        let $container = $(this).parents('.button-container');
        let $custom_edits = $($container).find('.quick-add-row').find('.custom-value-edit:not(.bootstrap-select)'),
            table = $($container).find('.table-container').attr('data-table-id'),
            current_table = $($container).find('.table-container').attr('data-curren-table'),
            related_table_name = $(this).attr('data-table-name'), payload = [],
            $relations = $($container).find('.editable-td.update, .editable-td.is-required'),
            button_id = $(this).attr('data-button-id'),
            record_id = $(this).attr('data-record-id'),
            button_type = $(this).attr('data-button-type'),
            $related_section = $(this).parents('.tbl-section.related').find('.browse-table').find('tbody'),
            $sort = $(this).parents('.tbl-section.related').find('.section-sorting-dropdown').find('.sort-field').find('.active'),
            $scroll_table = $(this).parents('.tbl-section.related').find('.table-responsive'),
            section_id = $(this).parents('.tbl-section.related').attr('data-section-id'),
            owner_record = $($container).find('.table-container').attr('data-owner-record'),
            owner_table = $($container).find('.table-container').attr('data-owner-table'),
            vat_zone = $('.hidden-relation[name="vat_zone"]').val(), view = $(this).attr('data-view'),
            $mobile_container = $container.find('.mobile-quick-add'),
            $spinner = $(this).find('.spinner-border'),
            record_count = parseInt($(this).attr('data-record-count')),
            $btn = $(this);

        if(record_count){
            record_count = prompt('Specify records to create');
        }

        if (view === 'mobile') {
            $related_section = $(this).parents('.tbl-section.related').find('.mobile-rows-container');

            if ($mobile_container.children().length > 0) {
                if ($mobile_container.hasClass('d-none')) {
                    $mobile_container.slideDown().removeClass('d-none');
                    return;
                }
            }
        }

        $spinner.removeClass('d-none');
        $btn.prop('disabled', true);

        $custom_edits.each(function (i, $edit) {
            let $editable = $(this).parents('.editable-td'),
                field_id = $editable.attr('data-field'),
                value = $(this).val();

            if ($($edit).hasClass('html-field')) {
                value = $($edit).attr('data-html');
            }

            if ($($edit).hasClass('textarea-field')) {
                value = $($edit).attr('data-value');
            }

            if ($($edit).hasClass('selectpicker')) {
                if (!value.length) {
                    value = "";
                }
            }

            $editable.removeClass('error');

            payload.push({
                field_id, value
            });
        });

        $relations.each(function (i, $edit) {
            let field_id = $($edit).attr('data-field'),
                value = $($edit).attr('data-value');

            $($edit).removeAttr('data-old-text').removeAttr('data-old-value');

            payload.push({
                field_id, value
            });
        });

        $.ajax({
            type: 'POST', url: '/tables/quick_add', data: {
                table, payload, button_id, record_id, current_table,
                related_table_name, vat_zone, owner_record, owner_table,
                section_id, record_count,
                source: 'section_insert',
            }, success: function (res) {
                if (!res.errors) {
                    showAlert(translation.fields_inserted, 'alert-success');
                    $related_section.parents('.lazy-load-section').removeClass('no-records');

                    let timeout = 1000;

                    let print_payload = [];

                    if(res.pdfs.length){
                        $(res.pdfs).each(function(index, pdf){


                            if(window.tenant === 'pancetop' && parseInt(pdf.printer)){
                                print_payload.push(pdf.url); // Add URL to the printer's payload
                                timeout = 10000;
                            }else{
                                let pdfw = window.open(pdf.url, '_blank');

                                if (pdfw !== null) {
                                    pdfw.focus();
                                    pdfw.onload = function () {
                                        pdfw.print();
                                    }
                                } else {
                                    bootbox.alert(translation.popup_blocked);
                                }
                            }
                        });

                        // Call printDocuments only once after constructing the payload
                        if (print_payload.length) {
                            printDocuments(print_payload);
                        }
                    }

                    if (button_type === 'section_insert') {
                        $related_section.parents('.table_container').removeClass('d-none');
                        $mobile_container.slideUp().addClass('d-none');
                        $related_section.append(res.dom);
                        if (res.bundle_items.length) {
                            $related_section.append(res.bundle_items);

                            let $row = $($(res.bundle_items)[0]);
                            updateBundleSubTotal($related_section, $row);
                        }
                        $scroll_table.animate({scrollTop: $(document).height()}, "slow");
                        clearQuickAdd($container);
                        formula_functions.processSectionFormulas();

                        let editing = $related_section.find('.custom-value-edit').length,
                            edit_relations = $related_section.find('.editable-td.update').length,
                            filter_selected = $('body').find(`.apply-section-filter.applied[data-table-id="${current_table}"]:not([data-filter-id="x"])`).length,
                            sort_selected = $sort.length;

                        console.log(filter_selected, editing, edit_relations);

                        if (sort_selected && (editing || edit_relations)) {
                            $('.save-edit').trigger('click', ['save_with_sort', $sort]);
                        } else if(sort_selected){
                            $sort.trigger('click');
                        }

                        if (filter_selected && (editing || edit_relations)) {
                            $('.save-edit').trigger('click', ['save_with_filter', current_table]);
                        } else if (editing || edit_relations) {
                            applySectionFilter(current_table)
                        }

                        if (res.error.length) {
                            toastr.error(res.error);
                        }
                    } else {
                        setTimeout(function () {
                            window.location.reload();
                        }, timeout);
                    }
                } else {
                    renderCreateErrors(res.errors);
                }

                $spinner.addClass('d-none');
                $btn.prop('disabled', false);
            }
        });
    });

    function printDocuments(urls) {
        toastr.info(`Dispatched ${urls.length} pdfs print jobs`);

        urls.forEach(url => {
            const separator = url.includes('?') ? '&' : '?';
            const modifiedUrl = `${url}${separator}print_template=true`;

            $.ajax({
                type: 'GET',
                url: modifiedUrl,
                success: function(res) {
                },
                error: function() {
                    toastr.error(`Failed to dispatch print job for: ${modifiedUrl}`);
                }
            });
        });
    }

    function applySectionFilter(current_table) {
        $('body').find(`.apply-section-filter.applied[data-table-id="${current_table}"]:not([data-filter-id="x"])`).trigger('click');
    }

    function clearQuickAdd($container) {
        $container.find('input').each(function (i, $input) {
            if ($($input).attr('data-default-value') !== 'undefined') {
                if ($($input).attr('data-type') === 'formula') {
                    $($input).val(0);
                } else {
                    $($input).val($($input).attr('data-default-value'));
                }
            } else {
                $($input).val('');
            }
        });

        $container.find('.editable-td[data-field-type="relationship"]').removeClass('update').attr('data-value', '');
        $container.find('.html-field').attr('data-html', '');
        $container.find('.textarea-field').attr('data-value', '');
        $container.find('.edit-relation').removeClass('show-edit');
    }

    function renderCreateErrors(errors) {
        errors.forEach(function (error, index) {
            let $target = $(`.quick-add-row`).find(`.editable-td[data-field="${error.target}"]`);

            if (index === 0) {
                let offset = $($target).offset();

                $('html, body').animate({
                    scrollTop: offset.top - 250,
                });
            }
            $target.addClass('error');
        });
    }

    function renderUpdateErrors(res, $container) {

        res.forEach(function (errors, top_index) {

            errors.forEach(function (error, index) {

                let data = error.data;
                let $container = null;
                let target = $('.search-table').length ? '.search-table' : '.browse-table';

                if (data.type !== 'undefined' && data.type === 'related') {
                    let $container = $(`.tbl-section.related[data-section-id="${data.section_id}"]`);
                }

                if ($container) {
                    target = $container;
                }

                let $target = $(target).find(`#${error.target}`);
                if (index === 0) {
                    let offset = $($target).offset();
                    $('html, body').animate({
                        scrollTop: offset.top - 250,
                    });
                }
                $target.addClass('error');
                let keys = Object.keys(error.errors);
                $target.attr('title', error.errors[keys[0]][0]);
                $target.tooltip();
            });
        });
    }

    function renderUpdatedPayload(res, $container = null) {

        res.forEach(function (updates, top_index) {
            updates.forEach(function (update, index) {
                let data = update.data;
                let $container = null;
                let target = $('.search-table').length ? '.search-table' : '.browse-table';

                if (data.type !== 'undefined' && data.type === 'related') {
                    $container = $(`.tbl-section.related[data-section-id="${data.section_id}"]`);
                }

                if ($container) {
                    target = $container;
                }

                let $field = $(target).find(`#${update.target}`), value = '', name = $field.attr('data-field-name');

                if (update.display_value.length) {
                    if (update.type !== 'checkbox') {
                        value = update.display_value;
                    }
                    $field.attr('data-value', update.value);
                } else {
                    value = $field.find('.edit-value-holder').find('.custom-value-edit:not(.bootstrap-select)').val();
                    $field.attr('data-value', value);
                }

                if (update.type === 'checkbox') {
                    $field.find('a').find('span').html(update.display_value);
                } else {
                    if (name === 'multi_assigned_to') {
                        $field.find('a').find('span').html(update.display_value);
                    } else {
                        $field.find('a').find('span').text(value);
                        applyColorOptions($field, value);
                    }
                }

                $field.find('.edit-value-holder').remove();
                $field.find('a').removeClass('d-none');
                if ($field.hasClass('error')) {
                    $field.removeAttr('title');
                }
                $field.removeClass('error');
            });
        });

        $('.edit-buttons').addClass('d-none');
    }

    function applyColorOptions($field, value) {
        let colors = $field.attr('data-colors');

        if (colors && colors.length) {
            colors = JSON.parse(colors);

            if (value.length && colors[value] !== 'undefined') {
                $field.find('a').find('span').css({
                    'background-color': colors[value], 'padding': '3px 13px', 'border-radius': '25px'
                });
            } else {
                $field.find('a').find('span').css({
                    'background-color': '', 'padding': '', 'border-radius': ''
                });
            }
        }

    }

    function showAlert(message, type) {
        toastr.success(message);
    }

    $body.on('click', '#check-records', function (e) {
        let $related_container = $(this).parents('.browse-table'),
            $section = $(this).parents('.tbl-section.related');

        if ($(this).is(':checked')) {
            $related_container.find('.sub_chk').prop('checked', true);
        } else {
            $related_container.find('.sub_chk').prop('checked', false);
        }

        toggleRelatedSectionPrintIcons($section);
    });

    $body.on('click', '.sub_chk', function () {
        let $related_container = $(this).parents('.browse-table'),
            $section = $(this).parents('.tbl-section.related'),
            checked_length = $related_container.find('.sub_chk:checked').length,
            all_checks = $related_container.find('.sub_chk').length,
            $check_all = $related_container.find('#check-records');

        if (checked_length === all_checks) {
            $check_all.prop('checked', true);
        } else {
            $check_all.prop('checked', false);
        }

        toggleRelatedSectionPrintIcons($section);
    });

    function toggleRelatedSectionPrintIcons($section) {
        if ($section.find('.sub_chk:checked').length && $section.find('.tmp-preview').length) {
            $section.find('.tmp-preview').removeClass('d-none').addClass('d-inline-block');
        } else {
            $section.find('.tmp-preview').addClass('d-none').removeClass('d-inline-block');
        }
    }

    $body.on('mouseover', '.failed-delete', function (e) {
        $(this).removeClass('failed-delete');
    });

    $body.on('click', '.delete-related-data', function (e) {
        e.preventDefault();

        let idsArr = [], table_name = $(this).data('table-plural'), id = $(this).attr('data-id'),
            owner_table = $(this).attr('data-owner-table'), owner_record = $(this).attr('data-owner-record'),
            related_section_id = $(this).attr('data-related-section'), view = $(this).attr('data-view');

        let $container = $(this).parents('.tbl-section'),
            section_name = $container.parents('.lazy-load-section').attr('data-table-name');

        $container.find(".sub_chk:checked").each(function () {
            idsArr.push($(this).attr('data-id'));
        });

        if (idsArr.length <= 0) {
            alert("Please select atleast one record to delete.");
        } else {
            if (confirm("Are you sure, you want to delete the selected data?")) {

                let strIds = idsArr.join(",");
                $.ajax({
                    url: "/delete-multiple-fields", type: 'DELETE', data: {
                        ids: strIds, id: id, owner_record, owner_table, related_section_id
                    }, success: function (data) {
                        let failed_ids = data.failed_ids, removed_ids = data.removed_ids;

                        if (failed_ids.length) {
                            toastr.error(
                                `<a href="${failed_urls[0]}"><button type="button" class="btn btn-sm btn-light w-100 mt-2"> ${translation.view_record} </button></a>`,
                                data['failed_message']
                            );
                            failed_ids.forEach(id => {
                                $container.find('.sub_chk[data-id="' + id + '"]').each(function () {
                                    $(this).parents("tr").addClass('failed-delete');
                                });
                            });
                        }

                        if (removed_ids.length) {
                            toastr.success(data['message']);
                            removed_ids.forEach(id => {
                                if (view === 'mobile') {
                                    $container.find('.sub_chk[data-id="' + id + '"]').each(function () {
                                        $(this).parents(".mobile-rows").remove();
                                    });
                                } else {
                                    $container.find('.sub_chk[data-id="' + id + '"]').each(function () {

                                        let bundle_sections = ['Quote_products', 'Invoice_Products', 'Sales_order_products'],
                                            $row = $(this).parents("tr"),
                                            bundle_id = false;

                                        if (tenant_name === 'dobrovita' && bundle_sections.includes(section_name)) {
                                            bundle_id = $row.find('td[data-field-name="quantity"]').attr('data-bundle-id');
                                        }

                                        $(this).parents("tr").remove();

                                        if (tenant_name === 'dobrovita' && bundle_sections.includes(section_name) && bundle_id) {
                                            $row = $container.find(`td[data-field-name="quantity"][data-bundle-id="${bundle_id}"]`).parents('tr');
                                            if ($row.length) {
                                                updateBundleSubTotal($container, $($row[0]));
                                            }
                                        }
                                    });
                                }

                            });
                            formula_functions.executeFormulas();
                            formula_functions.processSectionFormulas();
                            $('.response-related-section').trigger('resize');
                        }
                    }, error: function (data) {
                        alert(data.responseText);
                    }
                });
            }
        }
    });

    $(document).on('change', 'input[name="same_shipment_address"]', function () {
        let $container = $(this).parents('form'),
            table_name = $('.create-update-fields').attr('data-table-name');

        if ($container.hasClass('create-dialog-form')) {
            table_name = $('#create-record').attr('data-table-name');
        }

        if (table_name === 'Companies') {
            $container.find('input[name="billing_street"]').trigger('keyup');
            $container.find('input[name="billing_postal_code"]').trigger('keyup');
            $container.find('input[name="billing_city"]').trigger('keyup');
            $container.find('.hidden-relation[name="billing_country"]').trigger('keyup');
        } else if (table_name === 'Leads') {
            $container.find('input[name="street"]').trigger('keyup');
            $container.find('input[name="postal_code"]').trigger('keyup');
            $container.find('input[name="city"]').trigger('keyup');
            $container.find('.hidden-relation[name="country"]').trigger('keyup');
        }
    });

    $(document).on('keyup', 'input[name="billing_street"], input[name="billing_postal_code"], input[name="billing_city"], .hidden-relation[name="billing_country"], input[name="street"], input[name="postal_code"], input[name="city"], .hidden-relation[name="country"]', function (e) {
        let $container = $(this).parents('form'),
            table_name = $('.create-update-fields').attr('data-table-name');

        if ($container.hasClass('create-dialog-form')) {
            table_name = $('#create-record').attr('data-table-name');
        }

        let same_shipment_address = $container.find('input[name="same_shipment_address"]').is(':checked');
        let value = $(this).val();

        if (table_name === 'Companies') {
            if ($(this).attr('name') === 'billing_street') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_street"]').val(value);
                }
            } else if ($(this).attr('name') === 'billing_postal_code') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_postal_code"]').val(value);
                }
            } else if ($(this).attr('name') === 'billing_city') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_city"]').val(value);
                }
            } else if ($(this).hasClass('hidden-relation') && $(this).attr('name') === 'billing_country') {
                let text = $container.find('.relation-data-field[name="billing_country"]').val();
                console.log(value, text);
                if (same_shipment_address) {
                    $container.find('.relation-data-field[name="shipping_country"]').val(text);
                    $container.find('.hidden-relation[name="shipping_country"]').val(value);
                }
            }
        } else if (table_name === 'Leads') {
            if ($(this).attr('name') === 'street') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_street"]').val(value);
                }
            } else if ($(this).attr('name') === 'postal_code') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_postal_code"]').val(value);
                }
            } else if ($(this).attr('name') === 'city') {
                if (same_shipment_address) {
                    $container.find('input[name="shipping_city"]').val(value);
                }
            } else if ($(this).hasClass('hidden-relation') && $(this).attr('name') === 'country') {
                let text = $container.find('.relation-data-field[name="country"]').val();
                if (same_shipment_address) {
                    $container.find('.relation-data-field[name="shipping_country"]').val(text);
                    $container.find('.hidden-relation[name="shipping_country"]').val(value);
                }
            }
        }
    });


    if ($('input[name="default"]').length && ($('.edit-form').length || $('.create-form').length)) {
        let table_id = 0;
        if ($('.create-form').length) {
            table_id = parseInt($('.create-form').attr('data-id'));
        }

        if ($('.edit-form').length) {
            table_id = parseInt($('.edit-form').attr('data-id'));
        }

        $('input[name="default"]').on('change', function () {
            if (table_id === 42 && $(this).is(':checked')) {
                $.ajax({
                    type: 'GET', url: '/location/exist', success: function (res) {
                        if (res.exists) {
                            bootbox.confirm(res.message, function (result) {
                                if (!result) {
                                    $('input[name="default"]').prop('checked', false);
                                }
                            })
                        }
                    }
                })
            }
        });
    }

    $(document).on('click', '.toggle-section-collapse', function (e) {
        let show = parseInt($(this).attr('data-show')),
            section_id = $(this).attr('data-section-id'),
            $header = $(this).parents('.rel-sec-header');

        if(is_mobile && !show){
            $header.css({
                'border-bottom-left-radius' : '0',
                'border-bottom-right-radius' : '0'
            })
        }

        if(is_mobile && show){
            $header.css({
                'border-bottom-left-radius' : '10px',
                'border-bottom-right-radius' : '10px'
            })
        }

        $(this).attr('data-show', show ? 0 : 1);

        $.ajax({
            type: 'POST', url: '/tables/section/toggle', data: {
                show: show ? 0 : 1, section_id
            }
        })
    });

    $('.multi-selectpicker').on('change', function () {
        const $select = $(this);
        const $hiddenInput = $(this).parents('.select-picker').find('input[type="hidden"]');
        const selectedValues = $select.val();

        if (!selectedValues || selectedValues.length === 0) {
            $hiddenInput.val('[]'); // Clear hidden input when no selection
        } else {
            $hiddenInput.val($select.prop('multiple') ? JSON.stringify(selectedValues) : selectedValues);
        }
    });
});

function delay(callback, ms) {
    let timer = 0;
    return function () {
        let context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}